const status = {
  employed: [
    {
      name: "Probationary",
      abbr: "prob",
      group: "Currently Employed",
      description: "Newly hired and under evaluation period.",
      isEmployed: true,
    },
    {
      name: "Regular",
      abbr: "active",
      group: "Currently Employed",
      description: "Fully employed after passing probationary period.",
      isEmployed: true,
    },
    {
      name: "Part-time",
      abbr: "pt",
      group: "Currently Employed",
      description: "Works fewer hours than a full-time employee.",
      isEmployed: true,
    },
    {
      name: "Contractual",
      abbr: "cont",
      group: "Currently Employed",
      description: "Employed under a fixed-term contract.",
      isEmployed: true,
    },
    {
      name: "Project-Based",
      abbr: "prj",
      group: "Currently Employed",
      description: "Hired to work on a specific project or assignment.",
      isEmployed: true,
    },
    {
      name: "Seasonal",
      abbr: "seas",
      group: "Currently Employed",
      description: "Employed only during certain seasons or periods.",
      isEmployed: true,
    },
    {
      name: "Reliever",
      abbr: "rlr",
      group: "Currently Employed",
      description: "Temporarily filling in for an absent employee.",
      isEmployed: true,
    },
    {
      name: "Honorarium",
      abbr: "hon",
      group: "Currently Employed",
      description: "token of appreciation given for a service,.",
      isEmployed: true,
    },
    {
      name: "On-call",
      abbr: "onc",
      group: "Currently Employed",
      description: "Works only when called or needed.",
      isEmployed: true,
    },
    {
      name: "On Leave",
      abbr: "lv",
      group: "Inactive",
      description: "Temporarily away from work with approved leave.",
      isEmployed: true,
    },

    {
      name: "Resigned (Pending Clearance)",
      abbr: "rpc",
      group: "Inactive",
      description: "Resigned but still undergoing clearance process.",
      isEmployed: true,
    },

    {
      name: "End of Contract",
      abbr: "eoc",
      group: "Inactive",
      description: "Finished the duration of a fixed-term contract.",
      isEmployed: true,
    },
  ],
  nonEmployed: [
    {
      name: "Suspended",
      abbr: "sus",
      group: "Inactive",
      description:
        "Temporarily not allowed to work due to disciplinary action.",
      isEmployed: false,
    },
    {
      name: "AWOL",
      abbr: "awol",
      group: "Inactive",
      description: "Absent without official leave or notice.",
      isEmployed: false,
    },

    {
      name: "Retired",
      abbr: "ret",
      group: "Separated",
      description: "Ended employment due to reaching retirement age.",
      isEmployed: false,
    },
    {
      name: "Terminated",
      abbr: "term",
      group: "Separated",
      description: "Employment ended by the company due to cause.",
      isEmployed: false,
    },
    {
      name: "Laid Off",
      abbr: "lof",
      group: "Separated",
      description: "Let go due to redundancy or business restructuring.",
      isEmployed: false,
    },
    {
      name: "Deceased",
      abbr: "dec",
      group: "Separated",
      description: "Employment ended due to employee's death.",
      isEmployed: false,
    },
    {
      name: "Blacklisted",
      abbr: "blk",
      group: "Separated",
      description: "Not eligible for rehire due to serious violations.",
      isEmployed: false,
    },
    {
      name: "Applicant",
      abbr: "app",
      group: "Pre-employment",
      description: "Submitted application but not yet processed.",
      isEmployed: false,
    },
    {
      name: "For Interview",
      abbr: "int",
      group: "Pre-employment",
      description: "Shortlisted and waiting for interview schedule.",
      isEmployed: false,
    },
    {
      name: "For Hiring",
      abbr: "hir",
      group: "Pre-employment",
      description: "Passed evaluation and ready for hiring.",
      isEmployed: false,
    },
    {
      name: "For Medical",
      abbr: "med",
      group: "Pre-employment",
      description: "Undergoing pre-employment medical checkup.",
      isEmployed: false,
    },
    {
      name: "For Orientation",
      abbr: "ori",
      group: "Pre-employment",
      description: "Ready to be onboarded; awaiting orientation.",
      isEmployed: false,
    },
  ],
};

export default status;
